import React from "react"
import { Layout, Header, Hero, SEO, Feedback, Footer } from "../components"

const IndexPage = () => {
	return (
		<Layout>
			<SEO
				title="Wall of Love - SHEROES, The Women-Only Social Network"
				description="Wall of Love is a showcase of the appreciation for SHEROES, the largest women-only online community. Read the SHEROES testimonials, reviews, experiences here."
			/>
			<Header />
			<Hero />
			<Feedback />
			<Footer />
		</Layout>
	)
}

export default IndexPage
